import {
    Button,
    Inputfield,
    Inputarea,
    Checkbox
} from '@/framework';

const globalComponents = {
    install(Vue){
        Vue.component(Button.name,Button);
        Vue.component(Inputfield.name,Inputfield);
        Vue.component(Inputarea.name,Inputarea);
        Vue.component(Checkbox.name,Checkbox);
    }
}

export default globalComponents;